import { render, staticRenderFns } from "./StockTradeDocumentForm.vue?vue&type=template&id=b6707e00&scoped=true"
import script from "./StockTradeDocumentForm.vue?vue&type=script&lang=js"
export * from "./StockTradeDocumentForm.vue?vue&type=script&lang=js"
import style0 from "./StockTradeDocumentForm.vue?vue&type=style&index=0&id=b6707e00&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6707e00",
  null
  
)

export default component.exports